import { DetailText } from "@gnist/design-system";
import React from "react";
import { styled } from "styled-components";
import { tokens } from "@gnist/themes/tokens.css.js";

const DepartmentDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.base};
`;

const Department = styled(DetailText)`
  font-size: ${tokens.typeface.size.s};
  font-weight: 400;
`;

type props = {
  departmentName: string;
};

const DepartmentSection = ({ departmentName }: props) => {
  return (
    <DepartmentDiv>
      <Department>{departmentName}</Department>
    </DepartmentDiv>
  );
};

export default DepartmentSection;
